<template>
  <div id="hours-data-analysis"></div>
</template>

<script>
export default {
  data(){
    return{
      resourceData:this.initData(),
      type:['temperature','humidity','speed']
    }
  },
  props:["activeKey"],
  mounted() {
    this.queryDeviceHoursEnviData();
    console.log(this.resourceData)
  },
  methods: {
    initData(){
      let arr = []
      for(let i=0;i<24;i++){
        arr.push({
          hour: i < 10 ? '0'+i : ''+i,
          humidity:0,
          humidityUnit:'%',
          speed:0,
          speedUnit:'m/s',
          temperature:0,
          temperatureUnit:'℃'
        })
      }
      return arr
    },
    queryDeviceHoursEnviData(){
      this.$api.queryDeviceHoursEnviData({size:24}).then(res =>{
        if(res.code === 200){
          let records = (res.data && res.data.records) || []
          let resourceData = [...this.resourceData]
          records.forEach(item =>{
            resourceData.forEach(v =>{
              if(v.hour == item.hour){
                v.humidity = item.humidity
                v.temperature = item.temperature
                v.speed = item.speed
              }
            })
          })
          this.resourceData = resourceData
          this.renderChart(this.resourceData,this.activeKey)
        }
      })
    },
    renderChart(resourceData,key) {
      // 基于准备好的dom，初始化echarts实例
      let typeList = ['temperature','humidity','speed']
      let myChart = this.$echarts.init(
        document.getElementById("hours-data-analysis")
      );
           // 蓝色
      let blueIcon =
        '<svg width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg"><g transform="translate(.719 .564)" fill="none" fill-rule="evenodd"><circle stroke="#57F7FF" fill="#323538" cx="4.833" cy="4.833" r="4.333"/><circle fill="#57F7FF" cx="4.833" cy="4.833" r="1.758"/></g></svg>';
      blueIcon = encodeURIComponent(blueIcon); // 转译
      blueIcon = "data:image/svg+xml;utf8," + blueIcon; // 添加url前缀
      blueIcon = "image://" + blueIcon; // 添加ECharts需要的前缀
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        xAxis: {
          type: "category",
          boundaryGap: true,
          interval :10,
          data: resourceData.map(item => item.hour),
          axisLine: {
            lineStyle: {
              // 设置x轴颜色
              color: "rgba(255,255,255,0.8)"
            },
          },
          axisTick:{
            show:false,
            interval:4,
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "5%",
          containLabel: true
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              // 设置x轴颜色
              color: "#D2D2D2"
            }
          },
          splitLine:{
            lineStyle:{
                color:'#25517E'
              }
          },
          axisTick:{
            show:false
          }
        },
        series: [
          {
            data: resourceData.map(item => item[typeList[key]]),
            type: "line",
            
            areaStyle: { color: "rgba(87,247,255,0.5)" },
            symbolSize: 10,
            symbol: blueIcon,
            itemStyle: {
              normal: {
                // 拐点上显示数值
                label: {
                  show: false
                },
                borderColor: "rgba(87,247,255,0.5)", // 拐点边框颜色
                lineStyle: {
                  //   width: 5, // 设置线宽
                  type: "solid", //'dotted'虚线 'solid'实线
                  color:'rgba(87,247,255,0.8)'
                }
              }
            }
          }
        ],
        color: ["rgba(87,247,255,1)"]
      });

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    
  },
  watch:{
      activeKey(v){
        this.renderChart(this.resourceData,v)
      }
    }
};
</script>